import { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";
import moment from "moment";

export const createSupplier = (supplierData: any): Promise<AxiosResponse> => {
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (company.id) {
    supplierData["customer"] = company.id;
  }
  return axiosAuth.post(API_PATH().apis.supplier, supplierData);
};
export const getSupplierList = (
  page: number,
  limit: number,
  search: string
): Promise<AxiosResponse> => {
  const params: any = {
    page,
    limit,
    search,
  };
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (company.id) {
    params["customer"] = company.id;
  }
  let config: AxiosRequestConfig = {
    params,
  };
  return axiosAuth.get(API_PATH().apis.suppliers, config);
};

export const getSupplierDetails = (
  id: number,
  otp?: string | null
): Promise<AxiosResponse> => {
  return axiosAuth.get(API_PATH().apis.supplier + "/" + id);
};

export const getSupplierCount = (): Promise<AxiosResponse> => {
  let params: any = {};
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (company.id) {
    params["customer"] = company.id;
  }
  return axiosAuth.get(API_PATH().apis.supplierCount, { params });
};

export const updateMultipleSuppliers = (data: any): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.suppliers, data);
};

export const sendRegistrationRequest = (
  supplierId: any
): Promise<AxiosResponse> => {
  const data: any = {
    supplier: supplierId,
  };
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (company.id) {
    data["customer"] = company.id;
  }
  return axiosAuth.post(API_PATH().apis.registerSupplier, data);
};

export const validateSupplier = (supplierId: any, otp: any) => {
  return axiosAuth.post(API_PATH().apis.validateSupplier, { supplierId, otp });
};

export const getCustomerList = (
  page: number,
  limit: number,
  search: string
): Promise<AxiosResponse> => {
  const params: any = {
    page,
    limit,
    search,
  };
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (company.id) {
    params["company"] = company.id;
  }
  let config: AxiosRequestConfig = {
    params,
  };
  return axiosAuth.get(API_PATH().apis.customers, config);
};

export const getCustomerCount = () => {
  let params: any = {};
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (company.id) {
    params["company"] = company.id;
  }
  return axiosAuth.get(API_PATH().apis.customerCount, { params });
};

export const submitSupplierEmissions = (data: any) => {
  return axiosAuth.post(API_PATH().apis.supplierEmissions, data);
};

export const getYtdData = (year: string, company: number) => {
  let config: AxiosRequestConfig = {
    params: { year, company },
  };
  return axiosAuth.get(API_PATH().apis.supplierYtdData, config);
};

export const getTimePeriods = (
  year: string,
  company: number,
  customer: number
) => {
  let fromDate = moment()
    .set("year", Number(year))
    .startOf("year")
    .toISOString();
  let toDate = moment().set("year", Number(year)).endOf("year").toISOString();
  let config: AxiosRequestConfig = {
    params: { year, company, fromDate, toDate, customer },
  };
  return axiosAuth.get(API_PATH().apis.supplierTimePeriods, config);
};
export const getSupplierEmissions = (
  fromDate: string,
  company: number,
  customer: number,
  toDate: string
) => {
  let config: AxiosRequestConfig = {
    params: { fromDate, company, toDate, customer },
  };
  return axiosAuth.get(API_PATH().apis.supplierEmissions, config);
};

export const updateEmissionData = (data: any) => {
  return axiosAuth.put(API_PATH().apis.supplierEmissions, data);
};

export const getSupplierStatusAggregate = () => {
  let params: any = {};
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (company.id) {
    params["customer"] = company.id;
  }
  return axiosAuth.get(API_PATH().apis.supplierStatusAggregate, { params });
};

export const getEsgAggregate = (data: any) => {
  let params: any = {};
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (company.id) {
    params["customer"] = company.id;
  }
  params["from"] = data.from;
  params["to"] = data.to;
  return axiosAuth.get(API_PATH().apis.getSupplierESGData, { params });
};

export const getSupplierEmissionAggregate = (
  supplier: number,
  format: string,
  year?: number
) => {
  let params: any = {};
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (company.id) {
    params["customer"] = company.id;
  }
  params["format"] = format;
  params["supplier"] = supplier;
  if (year) {
    params["year"] = year;
  }
  return axiosAuth.get(API_PATH().apis.supplierEmissionAggregate, { params });
};

export const fetchSuppliersWithTotalEmissionRecords = (
  from: Date,
  to: Date,
  customerID: string,
  searchText: string,
  controller: any
) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let params: any = {};
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (customerID?.length) {
    params["customerID"] = customerID;
  } else if (company.id) {
    params["customerID"] = company.id;
  }
  if (searchText?.length) {
    params["searchText"] = searchText;
  }
  if (controller?.sortBy?.length) {
    params["sortBy"] = controller.sortBy;
  }
  if (controller?.sortOrder?.length) {
    params["sortOrder"] = controller.sortOrder;
  }
  params["fromMonth"] = months[from.getMonth()];
  params["fromYear"] = from.getFullYear();
  params["toMonth"] = months[to.getMonth()];
  params["toYear"] = to.getFullYear();
  return axiosAuth.get(API_PATH().apis.suppliersWithTotalEmissionRecords, {
    params,
  });
};

export const fetchSupplierAlocations = (
  from: Date,
  to: Date,
  customerID: string,
  supplierID: string
) => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let params: any = {};
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  params["customerID"] = customerID;
  params["supplierID"] = supplierID;
  params["fromMonth"] = months[from.getMonth()];
  params["fromYear"] = from.getFullYear();
  params["toMonth"] = months[to.getMonth()];
  params["toYear"] = to.getFullYear();
  return axiosAuth.get(API_PATH().apis.supplierAllocations, {
    params,
  });
};

export const createAdditionalField = (name: any) => {
  return axiosAuth.post(API_PATH().apis.supplierField, { name });
};
export const getOrgAdditionalFields = () => {
  return axiosAuth.get(API_PATH().apis.orgSupplierFields, {});
};

export const activateSupplier = (data: any) => {
  return axiosAuth.put(API_PATH().apis.activateSupplier, data);
};

export const updateSupplier = (data: any) => {
  return axiosAuth.put(API_PATH().apis.supplier, data);
};

export const getSupplierPreferences = (customerId: any) => {
  let params;
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (company.id) {
    params = { customerId: customerId, company: company.id };
  }
  return axiosAuth.get(API_PATH().apis.supplierPreferences, { params });
};

export const checkDuplicateSupplier = (field: string, value: string) => {
  let params;
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  if (company.id) {
    params = { customer: company.id, field: field, value: value };
  }
  return axiosAuth.get(API_PATH().apis.checkDuplicateSupplier, { params });
};

export const deleteUserAssociations = (): Promise<AxiosResponse> => {
  return axiosAuth.put(API_PATH().apis.deleteUserAssociations, {});
};

export const generateSupplierReport = (
  requestObject: any
): Promise<AxiosResponse> => {
  return axiosAuth.post(API_PATH().apis.supplierReport, requestObject, {
    responseType: "arraybuffer",
  });
};

export const getSupplierAllocationPreference = (customer: any) => {
  return axiosAuth.get(API_PATH().apis.supplierAllocationPreference, {
    params: { customer: customer },
  });
};

export const getSupplierAllocatedEmissions = (
  fromDate: any,
  toDate: any,
  isInvestor = false
) => {
  const company = JSON.parse(localStorage.getItem("company") || "{}");
  return axiosAuth.get(API_PATH().apis.supplierAllocatedEmissions, {
    params: {
      customerID: company.id,
      fromDate,
      toDate,
      allocationType: isInvestor ? "investments" : "",
    },
  });
};
